export class AbortError extends Error {
  cause: unknown;

  /*                                            */
  name = "AbortError" as const;

  constructor(message: string, options?: ErrorOptions) {
    super(message, options);
    /*          */
    this.cause ??= options?.cause;
  }
}
